module.exports = __webpack_public_path__ + "icons/icon-gear.73b6d848.svg";